module.exports = __webpack_public_path__ + "static/img/cangpin2.102ab45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cangpin2.png
// module id = pmf8
// module chunks = 26